/* eslint-disable react-hooks/rules-of-hooks -- hybrid statsig */
import {
    isNewStatsigSDK,
    statsigImport,
    statsigLegacyImport
} from '~/common/Statsig/hybridStatsig';
import {
    getLegacyStatsigClient,
    getStatsigClient
} from '~/common/Statsig/statsigClient';
import { useWarnAboutMissingStatsigProvider } from '~/common/Statsig/useWarnAboutMissingStatsigProvider';

export function useIsGateEnabled({
    gateName,
    defaultValue = false,
    enableExposure = true
}: {
    gateName: string;
    defaultValue?: boolean;
    enableExposure?: boolean;
}): boolean {
    useWarnAboutMissingStatsigProvider({ gateName });

    if (isNewStatsigSDK()) {
        return getStatsigClient().checkGate(gateName, {
            disableExposureLog: !enableExposure
        });
    } else {
        const useGateWithExposureLoggingDisabled = statsigLegacyImport(
            'useGateWithExposureLoggingDisabled'
        );
        // See comment in useMXExperimentConfigValue.ts
        //const gate = useGate(gateName);
        const gateWithExposureLoggingDisabled =
            useGateWithExposureLoggingDisabled(gateName);

        if (enableExposure) {
            manuallyLogGateExposure({ gateName });
        }

        return gateWithExposureLoggingDisabled.value ?? defaultValue;
    }
}

export function manuallyLogGateExposure({ gateName }: { gateName: string }) {
    if (isNewStatsigSDK()) {
        getStatsigClient().checkGate(gateName);
    } else {
        const Statsig = getLegacyStatsigClient();
        Statsig.manuallyLogGateExposure(gateName);
    }
}
